import CountryFlag from "react-country-flag";
import { InfiniteData } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import LeaderboardLoading from "./LeaderboardLoading";
import { JSX } from "react";

interface LogestDrivePlayerData {
  id: string;
  playername: string;
  nationality: string;
  score: {
    pos: number;
    driveDistance: number;
  };
}

interface EmbededGameData {
  data: {
    node: {
      embeddedGameLeaderboard: {
        records: { items: [LogestDrivePlayerData] };
      };
    };
  };
}
interface LongestDriveLeaderboardProps {
  data: undefined | InfiniteData<AxiosResponse<EmbededGameData, any>>;
  isLoading: boolean;
  ErrorMessage: () => JSX.Element | null;
}

const LongestDriveLeaderboard = ({
  data,
  isLoading,
  ErrorMessage,
}: LongestDriveLeaderboardProps) => {
  return (
    <div
      role="table"
      className="bg-[#2c2c2c] rounded-[10px] overflow-hidden min-h-[800px]"
    >
      <div
        role="thead"
        className={`flex justify-between bg-tm-c-gray-700 gap-[5px] md:gap-2.5
          px-2.5 py-0 lg:p-0
          [&>div]:py-[15px] [&>div]:px-0 [&>div]:flex-1 [&>div]:text-center [&>div]:text-xs lg:[&>div]:text-[15px]
        `}
      >
        <div role="th">Pos</div>
        <div role="th">
          <span className="hidden lg:block">Country</span>
        </div>
        <div role="th" className="!flex-[4] !text-left md:!flex-[5]">
          Player
        </div>
        <div role="th" className="md:!pr-[15px]">
          Distance
        </div>
      </div>
      <div role="tbody">
        <ErrorMessage />

        {data?.pages?.map((page: { data: EmbededGameData }, x: number) => {
          const itemsLength =
            page.data.data.node.embeddedGameLeaderboard.records.items.length;

          if (x === 0 && !itemsLength) {
            return (
              <h2
                key={x}
                className="text-tm-c-dark opacity-60 text-[25px] mt-[160px] mx-10 mb-0 text-center"
              >
                No results found
              </h2>
            );
          }

          return page.data.data.node.embeddedGameLeaderboard.records.items.map(
            (player: LogestDrivePlayerData) => {
              return (
                <div
                  role="tr"
                  className="flex flex-col justify-between overflow-hidden opacity-100 transition-opacity duration-300"
                  key={player.id}
                >
                  <div
                    role="tr"
                    className={`flex justify-between w-full gap-[5px] md:gap-2.5
                      py-0 px-2.5 lg:p-0
                      [&>div]:flex [&>div]:items-center [&>div]:justify-center [&>div]:flex-1 [&>div]:relative
                      [&>div]:text-center [&>div]:text-xs md:[&>div]:text-[15px]
                      [&>div]:py-[15px] [&>div]:px-0 md:[&>div]:last-of-type:pr-[15px]
                    `}
                  >
                    <div role="td">{player.score.pos}</div>
                    <div role="td">
                      {player.nationality && (
                        <CountryFlag
                          countryCode={player.nationality}
                          className="text-base lg:text-xl"
                          svg
                        />
                      )}
                    </div>
                    <div
                      role="td"
                      className="!flex-[4] !text-left md:!flex-[5] !justify-start"
                    >
                      {player.playername}
                    </div>
                    <div role="td" className="md:pr-[15px]">
                      {(player.score.driveDistance * 1.09361).toFixed(1)} yds
                    </div>
                  </div>
                </div>
              );
            }
          );
        })}
        {isLoading && <LeaderboardLoading loadingLayout="default" />}
      </div>
    </div>
  );
};

export default LongestDriveLeaderboard;
